import styled from "styled-components";
import { IconButton, Paper } from "@mui/material";

import { breakpoints, size } from "@/styles/breakpoints";

export const BottomSheetOverlay = styled.div`
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 1300;
    left: 0;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    transition: opacity 400ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: null;
    opacity: 1;
`;

export const BottomSheetContainer = styled(Paper)`
    width: 100%;
    max-height: 600px;
    flex-flow: column;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    transition: max-height 400ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const BottomSheetTitle = styled.div`
    font-size: var(--size-16);
    font-weight: bold;
    line-height: 21px;
    margin-top: 16px;
    color: var(--color-secondary);
    text-align: center;
    padding-right: 48px;
    padding-left: 48px;

    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;

export const BottomSheetDescription = styled.div`
    padding: 16px;
    max-width: ${size.sm};
    font-size: var(--size-14);
    line-height: 16px;
    color: var(--color-grey-900);
    padding-right: 48px;
    padding-left: 48px;

    @media ${breakpoints.xs} {
        font-size: var(--size-12);
    }
`;

export const BottomSheetAction = styled(IconButton)`
    right: 16px;
    top: 14px;
    position: absolute;
    cursor: pointer;
`;
